
export default () => {
  return {
    amount: 50,
    repetition: "regularly",
    amountOther: 0,
    amountOtherValue: null,

    init() {
      this.$refs.amountOtherNumber.addEventListener("focus", () => {
        this.$refs.amountOther.checked = true;
      })

      this.$refs.amountOtherGroup.addEventListener("click", () => {
        this.$refs.amountOtherNumber.focus();
      })

      this.$watch('amountOtherValue', () => {
        this.$refs.amountOther.value = this.amountOtherValue;
        this.amount = this.amountOtherValue;
        this.$refs.amountOther.checked = true;
      })
      this.$watch('amount', () => {
        if (this.amount != this.amountOtherValue) {
          this.amountOtherValue = null;
        }
      })

    },
    submit(event) {
      event.preventDefault();
      const form = document.forms.namedItem("donate-start");

      const formData = new FormData(form);
      if (formData.get('amount') == 'on') {
        this.$refs.amountOtherNumber.focus();
      } else {
        form.submit();
      }
    }
  }
}